/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useContext, useEffect} from 'react';
import Teams from '../../utils/api/Teams';
import {config} from '../../utils/config/config';
import Img7 from '../../assets/images/Velocity CS.png';
import {ARMcontext} from '../../utils/context/context';
import {useInputValue} from '../../utils/hooks/useInputValue';
import {SideBarTitle, SideBarSubtitle, RadiosContainer, SideBarLink, SideBar} from '../../components/sideBar/styles';
import {
  Navbar,
  TableEditDelete,
  FluidContainer,
  PowerDropdown,
  Radio,
  InputComponent,
  InputArea,
  InputDate,
  LargeButton,
  EmptyCard,
  EmptyImage,
} from '../../components';

const DefaultPlayers = [
  {title: 'All Players', lenght: 50},
  {title: 'Pitchers', lenght: 20},
  {title: 'Catchers', lenght: 30},
];
export default () => {
  const {teamMemo} = useContext(ARMcontext);
  const [radio, useRadio] = useState<any>({one: true, two: false});
  const [players, usePlayers] = useState<any>(DefaultPlayers);
  const [velocitys, useVelocitys] = useState<Array<any>>([]);
  const [player, usePlayer] = useState<any>(players[0]);
  const [team, useTeam] = useState<any>(teamMemo[0]);
  const [date, setDate] = useState(new Date());
  const [eventType, useEventType] = useState<string>('');
  const [situations, useSituations] = useState<Array<{title: string}>>([{title: 'Kneeling Rocker'}, {title: 'Second Option'}]);
  const [ballTypes, useBallTypes] = useState<Array<{title: string}>>([{title: '1KG Plybal'}]);
  const [pitchTypes, usePitchTypes] = useState<Array<{title: string}>>([{title: '2  Seam'}]);
  const [situation, useSituation] = useState<{title: string}>({title: 'Kneeling Rocker'});
  const [ballType, useBallType] = useState<{title: string}>({title: '1KG Plybal'});
  const [pitchType, usePitchType] = useState<{title: string}>({title: '2  Seam'});
  const note = useInputValue('');
  const velocity = useInputValue('');
  const TEAMS = new Teams();

  const velocityTableHead = [
    {
      title: 'PITCH',
      colSpan: '1',
      examType: ['player', 'fullName'],
    },
    {
      title: 'EVENT',
      colSpan: '1',
      examType: ['eventType'],
    },
    {
      title: 'SITUATION',
      colSpan: '1',
      examType: ['situation'],
    },
    {
      title: 'BALL TYPE',
      colSpan: '1',
      examType: ['ball_type'],
    },
    {
      title: 'PYTCH TYPE',
      colSpan: '1',
      examType: ['pitch_type'],
    },
    {
      title: 'VEL (MPH)',
      colSpan: '1',
      examType: ['velocity'],
    },
    {
      title: 'NOTE',
      colSpan: '1',
      examType: ['note'],
    },
    {
      title: 'EDIT',
      colSpan: '1',
      examType: ['edit'],
    },
    {
      title: 'DELETE',
      colSpan: '1',
      examType: ['delete'],
    },
  ];

  useEffect(() => {
    FetchPlayers();
  }, [team]);
  useEffect(() => {
    usePlayer(players[0]);
  }, [players]);
  useEffect(() => {
    if (radio.one) {
      useEventType('Game');
    }
    if (radio.two) {
      useEventType('Trainning');
    }
  }, [radio]);
  function handleDelete(id) {
    console.log('delete record', id);
    useVelocitys([...velocitys.filter(item => item._id !== id)]);
  }
  function handleEdit(id) {
    console.log('edit record', id);
  }

  function HandleRadiosButtons(e: any) {
    if (e.target.id === 'Trainning') {
      useRadio({one: false, two: true});
    } else {
      useRadio({one: true, two: false});
    }
  }
  function ChangeTeam(selectedTeam: any) {
    useTeam(selectedTeam);
  }
  function ChangePlayer(selectedOption: any) {
    usePlayer(selectedOption);
  }

  async function FetchPlayers(): Promise<void> {
    const resPlayers = await TEAMS.GetPlayersOfAteam(true, 1, team._id);
    if (resPlayers.data) {
      const playersFetched = await resPlayers?.data['player-teams']?.map(player => player.player);
      usePlayers(playersFetched);
    }
  }
  function editOptions(hook: any, prev: Array<any>) {
    const newoption: any = {title: prompt('Please enter new Option', '')};
    hook([...prev, newoption]);
    return;
  }
  function addData() {
    const form = {
      player: player,
      team: team,
      date: date,
      eventType: eventType || '',
      ball_type: ballType.title || '',
      pitch_type: pitchType.title || '',
      velocity: velocity.value || 0,
      situation: situation.title || '',
      notes: note.value,
      _id: player._id + velocitys.length + '_',
    };

    useVelocitys([...velocitys, form]);
    useRadio({one: true, two: false});
    useEventType('');
    note.HandleValue('');
  }

  return (
    <>
      <Navbar />
      {config.blocked ? (
        <div style={{display: 'flex', marginTop: '10px', flexDirection: 'column', alignItems: 'center'}}>
          <EmptyCard />
          <EmptyImage src={Img7} />
        </div>
      ) : (
        <FluidContainer>
          <div style={{display: 'flex', justifyContent: 'center', margin: '40px 0px 0px 0px'}}>
            <div data-cy="velocity_sidebar">
              <SideBar>
                <div style={{height: '100%', margin: '0px 43px 0px 45px'}}>
                  <SideBarTitle>VELOCITY TEST</SideBarTitle>
                  <div data-cy="teams-dropdown">
                    <PowerDropdown
                      primaryTitle={team?.name}
                      badge={team?.initials || team?.badge}
                      picture={team?.picture}
                      colorBadge={team?.color}
                      search={true}
                      onClick={ChangeTeam}
                      dataArray={teamMemo}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div data-cy="players-dropdown">
                    <SideBarSubtitle>Player</SideBarSubtitle>
                    <PowerDropdown
                      primaryTitle={player?.fullName || 'All Players'}
                      visibleLenght={players?.lenght}
                      picture={player?.picture || 'http://52.6.174.117:4000/file/c84e78e1-be0a-423a-94ba-220a5d7cd4efdefaultAvatar.png'}
                      search={true}
                      onClick={ChangePlayer}
                      dataArray={players}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div style={{display: 'block'}} data-cy="date-input">
                    <SideBarSubtitle>Date</SideBarSubtitle>
                    <InputDate date={date} setDate={setDate} />
                  </div>

                  <SideBarSubtitle>Event</SideBarSubtitle>
                  <RadiosContainer onChange={HandleRadiosButtons} data-cy="radio-panel">
                    <Radio title="Game" name="tableInfo" id="Game" checked={true} dynamicActive={radio?.one} />
                    <Radio title="Trainning" name="tableInfo" id="Trainning" checked={false} dynamicActive={radio?.two} />
                  </RadiosContainer>
                  <div style={{display: 'flex'}}>
                    <SideBarSubtitle>Situation</SideBarSubtitle>
                    <SideBarLink onClick={() => editOptions(useSituations, situations)}>Edit Options</SideBarLink>
                  </div>

                  <div data-cy="situation-dropdown">
                    <PowerDropdown
                      primaryTitle={situation?.title || 'N'}
                      onClick={useSituation}
                      search={true}
                      dataArray={situations}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div style={{display: 'flex'}}>
                    <SideBarSubtitle>Ball Type</SideBarSubtitle>
                    <SideBarLink onClick={() => editOptions(useBallTypes, ballTypes)}>Edit Options</SideBarLink>
                  </div>
                  <div data-cy="ball_type-dropdown">
                    <PowerDropdown
                      primaryTitle={ballType?.title}
                      search={true}
                      onClick={useBallType}
                      dataArray={ballTypes}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div style={{display: 'flex'}}>
                    <SideBarSubtitle>Pitch Options</SideBarSubtitle>
                    <SideBarLink onClick={() => editOptions(usePitchTypes, pitchTypes)}>Edit Options</SideBarLink>
                  </div>
                  <div data-cy="pitch_type-dropdown">
                    <PowerDropdown
                      primaryTitle={pitchType?.title}
                      search={true}
                      onClick={usePitchType}
                      dataArray={pitchTypes}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <SideBarSubtitle>Velocity (MPH)</SideBarSubtitle>
                  <div data-cy="velocity-input">
                    <InputComponent dynamicSearch={velocity} />
                  </div>

                  <SideBarSubtitle>Note (optional)</SideBarSubtitle>
                  <div data-cy="note-input">
                    <InputArea dynamicSearch={note} placeholder={'Input Text'} row={6} />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    margin: '25px 0px 0px 0px',
                  }}>
                  <LargeButton
                    title={'Add Data'}
                    callback={() => addData()}
                    lColor={'#fff'}
                    rColor={'linear-gradient(180deg, #1A88FF 0%, #007AFF 100%)'}
                    fColor="#ffffff"
                    bColor="#0086FF"
                    lMargin="0 0px"
                    rMargin="0 60px"
                    xMargin="0"
                  />
                </div>
              </SideBar>
            </div>

            <div style={{width: 'min-content'}}>
              <div data-cy="velocity-table">
                <TableEditDelete
                  dataTableContent={velocitys}
                  dataMainHead={[]}
                  dataTableHead={velocityTableHead}
                  onDelete={handleDelete}
                  onEdit={handleEdit}
                />
              </div>
              <div data-cy="session_complete" style={{display: 'flex', justifyContent: 'flex-end'}}>
                <LargeButton
                  title={'Session Complete'}
                  callback={() => console.log('session complete')}
                  lColor={'#fff'}
                  rColor={'linear-gradient(180deg, #FF3A1F 0%, #FF2608 100%)'}
                  fColor="#ffffff"
                  bColor="#FF472D"
                  lMargin="0 0px"
                  rMargin="0 60px"
                  xMargin="0"
                />
              </div>
            </div>
          </div>{' '}
        </FluidContainer>
      )}
    </>
  );
};
